import {
  Component,
  ChangeDetectionStrategy,
  forwardRef,
  Input,
  ViewChild,
  ElementRef,
  Injector,
  Output,
  EventEmitter
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../_shared/base.class';

@Component({
  selector: 'sc-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['../_shared/inputs.scss', './checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    class: 'sc-input'
  }
})
export class CheckboxComponent extends InputBase {
  @Input() type = 'checkbox';
  @Input() theme: 'default' | 'box' | 'block' = 'default';
  @Input() label: string;
  @Input() group: string;
  @Input() val: any = true;
  @Input() readonly: boolean;
  @Input() icon: string;

  @ViewChild('input', { static: true }) input: ElementRef;
  @Output() onupdate: EventEmitter<any> = new EventEmitter<any>();

  constructor(injector: Injector) {
    super(injector);
  }

  onInputChange(elem: HTMLInputElement) {
    if (this.type === 'checkbox') {
      const isChecked = !!elem.checked;
      if (!this.group) {
        this.onChange(isChecked);
      } else {
        const current = [...this.control.value];
        const index = current.findIndex(e => e === this.val);

        if (isChecked && index === -1) {
          current.push(this.val);
        }

        if (!isChecked && index !== -1) {
          current.splice(index, 1);
        }
        this.onChange(current);
      }
    } else {
      this.onChange(typeof this.val === 'number' ? +elem.value : elem.value);
    }
    this.onupdate.emit(this.value);
  }

  writeValue(delta: any): void {
    this._value = delta;
    if (this.type === 'checkbox' && this.group) {
      this.input.nativeElement.checked = (delta || []).includes(this.val);
    } else {
      this.input.nativeElement.checked = this.val === delta;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.input.nativeElement.disabled = !!isDisabled;
  }
}
